/**
 * Popular email domains ordered by usage/popularity
 * Used for email autocomplete suggestions
 */
export const POPULAR_EMAIL_DOMAINS = [
  "gmail.com",
  "yahoo.com",
  "outlook.com",
  "hotmail.com",
  "icloud.com",
  "protonmail.com",
  "aol.com",
  "mail.com",
  "yandex.com",
  "gmx.com",
  "zoho.com",
  "live.com",
  "msn.com",
  "qq.com",
  "163.com",
  "rediffmail.com",
  "sina.com",
  "sohu.com",
  "tutanota.com",
  "fastmail.com",
] as const;

export type PopularEmailDomain = typeof POPULAR_EMAIL_DOMAINS[number];

